<script setup>
import { inject, onMounted, ref, watch } from 'vue'
import { ApiService } from '@/js/services/api'

const props = defineProps({ filters: Object, api: String })
const emit = defineEmits(['input'])
const dataset = inject('dataset')

const grid = ref('')
const title = ref(null)
const page = ref(null)
const finished = ref(false)

const getGrid = async (page) => {
  const response = await ApiService.get(
    props.api +
      '?' +
      new URLSearchParams({
        page,
        ...parseFilters(),
      })
  )

  if (page == 1) grid.value = ''
  emit('input', response.count)

  if (response.count) {
    if (!title.value) title.value = response.results.title
    grid.value += response.results.html
  }

  if (response.next == null) finished.value = true
}

const parseFilters = () => {
  return Object.fromEntries(
    Object.entries(props.filters)
      .filter(([key, value]) => value && value.length)
      .map(([key, value]) => [
        key,
        Array.isArray(value) ? value.map((e) => e._id) : value,
      ])
  )
}

watch(
  () => props.filters,
  () => {
    getGrid(1)
  },
  { deep: true }
)

onMounted(() => {
  getGrid(1)
})
</script>

<template>
  <div class="notice-board-index pt-4" v-if="grid.length">
    <h2 class="is-size-2 mb-8" v-text="title"></h2>

    <div :class="dataset.narrow ? 'is-limited is-medium mx-auto' : ''">
      <div class="columns is-multiline is-grid" v-html="grid"></div>
    </div>

    <b-button
      type="is-primary"
      label="Vezi mai multe"
      outlined
      @click="getGrid(++page)"
      v-show="!finished"
    />
  </div>
</template>
